import { Component, OnInit } from '@angular/core';
import { CommonService } from '@app/core/services/common.service';
import { environment } from '@env/environment';
import * as jwt from "jsonwebtoken";

declare var $: any;
@Component({
  selector: 'sa-footer',
  templateUrl: './footer.component.html',
  styleUrls:['footer.component.scss']
})
export class FooterComponent implements OnInit {
  year = new Date().getFullYear();
  devOptionsRight:boolean = false;
  showDevOptions:boolean = false;
  pagePermission: any;

  constructor(private commonService: CommonService) {
    // let permissionCookie = this.commonService.getCookie(environment.permissions);
    // this.pagePermission = this.commonService.decrypt(decodeURIComponent(permissionCookie)).split(',');
  }

  ngOnInit() {
    // this.devOptionsRight = this.pagePermission.includes("admin.company.*");
  }
  openDevOption() {
    // $('#decodepopup').dialog("open");
    this.showDevOptions = !this.showDevOptions;
  }
  clear() {
    $('#encrypted').val('');
    $('#decrypted').val('');
  }

  decode() {
    let errorVal = '';
    let decryptedToken;
    if($('#encrypted').val()!='') {
      try{
        decryptedToken = this.commonService.decrypt($('#encrypted').val())
      }
      catch(Error){
        errorVal = "Not a valid Token";
      }
      if(errorVal==''){
        $('#decrypted').val(JSON.stringify(jwt.decode(decryptedToken), null, 2))
      }
      else{
        $('#encrypted').val(errorVal);
      }

    }
  }
}
